// API Configuration
// Base URL already includes /api (e.g., http://localhost:5000/api or https://api.usedadda.com/api)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Helper function to get full API URL
export const getApiUrl = (path) => {
  return `${API_BASE_URL}${path}`;
};

export default {
  API_BASE_URL,
  getApiUrl
};
